import { r, a as o } from "./_arrayPush-DUvcoEi5.mjs";
var s = r(), a = o(), b = "[object Symbol]";
function i(e) {
  return typeof e == "symbol" || a(e) && s(e) == b;
}
var m = i;
export {
  m as i
};
//# sourceMappingURL=isSymbol-BlvQGt6F.mjs.map
